import { createFileRoute } from '@tanstack/react-router';
import TrialSignupTemplate from '@/features/agent/account/templates/TrialSignupTemplate';

export const Route = createFileRoute('/account/trial')({
  component: TrialPage,
});

function TrialPage() {
  return <TrialSignupTemplate />;
}
